var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseSquare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4248 0.499023C22.6623 0.499023 25.4998 3.47402 25.4998 7.89902V18.1128C25.4998 22.5253 22.6623 25.499 18.4248 25.499H7.58726C3.34976 25.499 0.499756 22.5253 0.499756 18.1128V7.89902C0.499756 3.47402 3.34976 0.499023 7.58726 0.499023H18.4248ZM16.7623 9.21277C16.3373 8.78652 15.6498 8.78652 15.2123 9.21277L12.9998 11.4365L10.7748 9.21277C10.3373 8.78652 9.64976 8.78652 9.22476 9.21277C8.79976 9.63777 8.79976 10.3378 9.22476 10.7615L11.4498 12.9878L9.22476 15.2003C8.79976 15.6378 8.79976 16.3253 9.22476 16.749C9.43726 16.9615 9.72476 17.0753 9.99976 17.0753C10.2873 17.0753 10.5623 16.9615 10.7748 16.749L12.9998 14.5378L15.2248 16.749C15.4373 16.9753 15.7123 17.0753 15.9873 17.0753C16.2748 17.0753 16.5498 16.9615 16.7623 16.749C17.1873 16.3253 17.1873 15.6378 16.7623 15.2128L14.5373 12.9878L16.7623 10.7615C17.1873 10.3378 17.1873 9.63777 16.7623 9.21277Z",
    fill: "#FBFBFB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseSquare);
export default __webpack_public_path__ + "static/media/close-square.4e9be8ef.svg";
export { ForwardRef as ReactComponent };